import { Injectable } from '@angular/core';
import { UgcImage } from '@df/ugc-image/ugc-image';
import { UgcImageResource } from '@df/ugc-image/ugc-image.resource';
import take from 'lodash-es/take';

@Injectable({
    providedIn: 'root'
})
export class UgcImageService {
    constructor(private ugcImageResource: UgcImageResource) {}
    loadImages(ugcCategories?: number[], productIds?: number[], limit = 20, nywItemRangeCodeNh?: number[]): Promise<UgcImage[]> {
        return new Promise((resolve, reject) => {
            const filter: {
                product?: {
                    $in: number[];
                };
                product_type?: {
                    $in: number[];
                };
                nyw_item_range_code_nh?: {
                    $in: number[];
                };
            } = {};
            if (productIds?.length) {
                filter.product = { $in: productIds };
            }
            if (ugcCategories?.length) {
                filter.product_type = { $in: ugcCategories };
            }
            if (nywItemRangeCodeNh?.length) {
                filter.nyw_item_range_code_nh = { $in: nywItemRangeCodeNh };
            }
            this.ugcImageResource
                .find({ verbosity: 1, filter, limit, sort: { created_at: -1 } })
                .then(ugcImages => {
                    resolve(take(ugcImages, limit));
                })
                .catch(() => reject());
        });
    }
}
